import React from "react";
import {
    Typography,
    Button,
    TextField,
    Select,
    MenuItem,
    Box,
    Card,
    CardContent,
    FormControl,
    InputLabel,
    useTheme,
    useMediaQuery
} from "@mui/material"
import {
    Loader,
    ToastMessage
} from "../components/index"
import {
    useLazyUseGetAllPlatformsListQuery
} from "../Redux/actions/setting.action"
import {
    useLazyGetInstitutionClassesQuery
} from "../Redux/actions/classSetup.action"
import { useLazyGetAllExamsQuery } from "../Redux/actions/examAction"
import {
    updateFields,
    resetForm
} from "../Redux/actions/formValue.action"
import { useDownloadAdmitCardMutation } from "../Redux/actions/download.action"
import {
    useCheckAdmitCardPassMutation
} from "../Redux/actions/validateStudents.action"
import { useExaminationAdmitCardMutation, useLazyGetStudentAdmitDetailsQuery } from "../Redux/actions/examAction"
import { useSelector, useDispatch } from "react-redux"
import _ from "lodash"
import { useParams } from "react-router-dom"
import { useSnackbar } from "../components/Snakebar";

export default function PublicAdmitCard() {
    const dispatch = useDispatch()
    const { showSnackbar } = useSnackbar()
    const params = useParams()
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
    const [platforms, setPlatforms] = React.useState([])
    const [classesList, setClassesList] = React.useState([])
    const [openToasher, setOpenToasher] = React.useState(false)
    const [examListData, setExamList] = React.useState([])
    const [isInitialData, setIsInitialData] = React.useState(false)
    const { state } = useSelector((state) => state.form)


    const [getPlatformListAction, getPlatformListState] = useLazyUseGetAllPlatformsListQuery()
    const [getClassesAction, getClassesState] = useLazyGetInstitutionClassesQuery()
    const [downloadAdminAction, downloadAdmitState] = useDownloadAdmitCardMutation()
    const [validateStudentAction, validateStudentState] = useCheckAdmitCardPassMutation()
    const [getClassExams, getClassExamsState] = useLazyGetAllExamsQuery()
    const [downloadAdmit, downloadAdmitStates] = useExaminationAdmitCardMutation()
    const [getStudentAdmitApi, getStudentAdmitStatus] = useLazyGetStudentAdmitDetailsQuery()



    React.useEffect(() => {
        fetchInitialData()
        return () => {
            dispatch(resetForm())
        }
    }, [])

    function fetchInitialData() {
        if (Object.entries(params).length > 0) {
            const {
                school_id,
                class_id,
                exam_id,
                student_id
            } = params
            getStudentAdmitApi({
                school_id,
                class_id,
                exam_id,
                student_id
            })
        } else {
            getPlatformListAction()
        }
    }

    const validateStudentStatus = React.useMemo(() => {
        if (validateStudentState.isSuccess) {
            const data = _.get(validateStudentState, "data.admit_data", null)
            if (data) {
                downloadAdminAction(data)
                validateStudentState.reset()
            }
        }
        if (validateStudentState.isError) {
            const message = _.get(validateStudentState, "error.data.detail")
            setOpenToasher(true)
            return {
                "message": message,
                "type": "error",
                "open": true,
            }
        }
        // validateStudentState.reset()
    }, [validateStudentState])

    React.useEffect(() => {
        if (downloadAdmitStates.isSuccess && downloadAdmitStates.data) {
            const blobUrl = downloadAdmitStates.data // blob:xxxx

            const url = window.URL.createObjectURL(blobUrl)
            const a = document.createElement("a")
            a.href = url
            a.download = "admit-card.pdf"  // 🔥 REQUIRED
            document.body.appendChild(a)
            a.click();
            document.body.removeChild(a)

            // Optional: revoke blob to free memory
            URL.revokeObjectURL(blobUrl)
            downloadAdmitStates.reset()
            dispatch(resetForm())
        }
        if (downloadAdmitStates.isError) {
            let errorMessage = _.get(downloadAdmitStates, "error.data.detail", "")
            showSnackbar({
                message: errorMessage,
                severity: "error"
            })
            downloadAdmitStates.reset()
        }
    }, [downloadAdmitStates.status]);

    const platformList = React.useMemo(() => {
        if (getPlatformListState.isSuccess) {
            let list = _.get(getPlatformListState, "currentData.list", [])
            return list
        } else {
            return []
        }
    }, [getPlatformListState])
    const classes = React.useMemo(() => {
        if (getClassesState.isSuccess) {
            let list = _.get(getClassesState, "currentData.list", [])
            return list
        } else {
            return []
        }
    }, [getClassesState])
    const examList = React.useMemo(() => {
        if (getClassExamsState.isSuccess) {
            const list = _.get(getClassExamsState, "currentData.list", [])
            return list
        } else {
            return []
        }
    }, [getClassExamsState])


    React.useEffect(() => {
        if (platformList && platformList.length > 0) {
            setPlatforms(platformList)
        }
    }, [platformList])
    React.useEffect(() => {
        if (classes && classes.length > 0) {
            setClassesList(classes)
        }
    }, [classes])
    React.useEffect(() => {
        if (getStudentAdmitStatus.isSuccess) {
            const school = _.get(getStudentAdmitStatus, "currentData.school", [])
            const student = _.get(getStudentAdmitStatus, "currentData.student", [])
            const classdata = _.get(getStudentAdmitStatus, "currentData.class", [])
            const exam = _.get(getStudentAdmitStatus, "currentData.exam", [])
            setPlatforms(school)
            setClassesList(classdata)
            setExamList(exam)
            if (school.length && student.length && classdata.length && exam.length) {
                setIsInitialData(true)
                dispatch(updateFields({
                    institution_ref: school[0].id,
                    class_id: classdata[0].id,
                    rollNo: student[0]?.roll_no,
                    dob: student[0]?.dob,
                    exam: exam[0]?.id,
                    class_name: classdata[0]?.class_name
                }))
            }
        }
    }, [getStudentAdmitStatus.status])


    const school_id = state && _.get(state, "institution_ref", null)
    const class_id = state && _.get(state, "class_id", null)
    const roll_no = state && _.get(state, "rollNo", null)
    const dob = state && _.get(state, "dob", null)
    const exam = state && _.get(state, "exam", null)
    const class_name = _.get(state, "class_name", null)

    function fetchClassExamination({
        school_id,
        class_id
    }) {
        if (!school_id || !class_id) return
        getClassExams({
            school_id,
            class_id
        })
    }
    function fetchStudentAditCard({
        school_id,
        class_id,
        exam_id,
        roll_no,
        dob,
        class_name,
        call_type
    }) {
        if (!school_id || !class_id || !exam_id || !roll_no || !dob || !class_name) return
        const data = {
            school_id,
            class_id,
            exam_id,
            roll_no: Number(roll_no),
            dob,
            class_name,
            call_type
        }
        downloadAdmit(data)
    }

    const schoolList = platformList && platformList.length > 0 ? platformList : platforms
    const exams = examList && examList.length > 0 ? examList : examListData

    return (
        <Box
            sx={{
                width: "100%",
                minHeight: "100vh",
                background: "#f5f7fa",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: 2
            }}
        >
            <Card
                sx={{
                    width: isMobile ? "100%" : "50%",
                    borderRadius: 4,
                    padding: 3,
                    boxShadow: "0px 4px 20px rgba(0,0,0,0.1)"
                }}
            >
                <CardContent>
                    {/* Header */}
                    <Typography
                        variant="h4"
                        sx={{ textAlign: "center", fontWeight: 700, marginBottom: 2 }}
                    >
                        🎓 Download Examination Admit Card
                    </Typography>

                    <Typography
                        variant="body1"
                        sx={{ textAlign: "center", color: "gray", marginBottom: 3 }}
                    >
                        Enter your details below to view your examination admit card.
                    </Typography>

                    {/* Form Fields */}
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                        {
                            schoolList && Array.isArray(schoolList) && schoolList.length > 0 && (
                                <FormControl fullWidth>
                                    <InputLabel>Select School Or College</InputLabel>
                                    <Select
                                        label="Select School Or College"
                                        onChange={(e) => {
                                            let institution_ref = e.target.value
                                            if (institution_ref) {
                                                getClassesAction({
                                                    institution_ref: institution_ref
                                                })
                                            }
                                            dispatch(updateFields({ institution_ref: institution_ref }))
                                        }}
                                        value={_.get(state, "institution_ref", "")}
                                        disabled={isInitialData}
                                    >
                                        {
                                            schoolList.map((item, index) => {
                                                return (
                                                    <MenuItem value={item.id} key={index} >{item.name.toUpperCase()}</MenuItem>
                                                )
                                            })
                                        }
                                    </Select>
                                </FormControl>
                            )
                        }
                        {
                            classesList && Array.isArray(classesList) && classesList.length > 0 && (
                                <FormControl fullWidth>
                                    <InputLabel>Select Class</InputLabel>
                                    <Select
                                        label="Select Class"
                                        onChange={(e) => {
                                            let class_id = e.target.value
                                            if (class_id) {
                                                dispatch(updateFields({ class_id: class_id }))
                                                let findClass = classesList.find((item) => item.id === class_id)
                                                if (findClass) {
                                                    fetchClassExamination({
                                                        school_id: findClass.institution_ref,
                                                        class_id: findClass.id
                                                    })
                                                    dispatch(updateFields({ class_name: findClass.class_name }))
                                                }
                                            }
                                        }}
                                        value={_.get(state, "class_id", "")}
                                        disabled={isInitialData}
                                    >
                                        {
                                            classesList.map((cl, index) => {
                                                return (
                                                    <MenuItem value={cl.id} key={`${index}+${cl.class_name}`} >{cl.class_name}</MenuItem>
                                                )
                                            })
                                        }
                                    </Select>
                                </FormControl>
                            )
                        }

                        {
                            exams && Array.isArray(exams) && exams.length > 0 && (
                                <FormControl fullWidth>
                                    <InputLabel>Select Exam</InputLabel>
                                    <Select
                                        label="Select Exam"
                                        onChange={(e) => {
                                            let exam = e.target.value
                                            if (exam) {
                                                dispatch(updateFields({ exam: exam }))
                                            }
                                        }}
                                        value={_.get(state, "exam", "")}
                                        disabled={isInitialData}
                                    >
                                        {
                                            exams.map((ex, index) => {
                                                return (
                                                    <MenuItem value={ex.id} key={`${ex.id}+${index}`} >{ex.exam_name}</MenuItem>
                                                )
                                            })
                                        }
                                    </Select>
                                </FormControl>
                            )
                        }

                        <TextField
                            fullWidth
                            label="Roll Number"
                            placeholder="Enter your roll no"
                            onChange={(e) => {
                                let rollNo = e.target.value
                                dispatch(updateFields({ rollNo: rollNo }))
                            }}
                            value={_.get(state, "rollNo", "")}
                            disabled={isInitialData}
                        />

                        <TextField
                            fullWidth
                            label="Date Of Birth"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) => {
                                let dob = e.target.value
                                dispatch(updateFields({ dob: dob }))
                            }}
                            value={_.get(state, "dob", "")}
                            disabled={isInitialData}
                        />

                        {/* Submit Button */}
                        <Button
                            variant="contained"
                            fullWidth
                            sx={{
                                padding: "12px",
                                fontSize: "16px",
                                borderRadius: 2,
                                marginTop: 2
                            }}
                            disabled={!school_id || !class_id || !roll_no || !dob || !exam || !class_name}
                            onClick={() => {
                                fetchStudentAditCard({
                                    class_id: class_id,
                                    school_id: school_id,
                                    exam_id: exam,
                                    roll_no: roll_no,
                                    dob: dob,
                                    class_name: class_name,
                                    call_type: "student"
                                })
                            }}
                        >
                            Download
                        </Button>
                    </Box>

                    {/* Footer */}
                    <Typography
                        variant="caption"
                        sx={{
                            display: "block",
                            marginTop: 3,
                            textAlign: "center",
                            color: "gray"
                        }}
                    >
                        *Make sure details are correct before checking the examination admit card.
                    </Typography>
                </CardContent>
            </Card>
            {
                openToasher && (
                    <ToastMessage
                        message={validateStudentStatus?.message}
                        type={validateStudentStatus?.type}
                        open={openToasher}
                        onClose={() => {
                            setOpenToasher(false)
                            validateStudentState.reset()
                        }}
                    />
                )
            }
            {
                (
                    getPlatformListState.isLoading ||
                    getClassesState.isLoading ||
                    validateStudentState.isLoading ||
                    getClassExamsState.isLoading ||
                    downloadAdmitStates.isLoading ||
                    getStudentAdmitStatus.isLoading
                ) && (
                    <Loader show={true} />
                )
            }
        </Box>
    )
}
